const reportEvents = {
    RegionSelectionsChanged: {
        Name: "REPORT.REGIONSELECTIONSCHANGED",
        New(audit, division, district, dateRange) {
            return {
                type: reportEvents.RegionSelectionsChanged.Name,
                Audit: audit, 
                Division: division,
                District: district,
                DateRange: dateRange
            };
        }
    }, 
    AuditSelectionChanged: { 
        Name: "REPORT.AUDITSELECTIONCHANGED",
        New(audit) {
            return {
                type: reportEvents.AuditSelectionChanged.Name,
                Name: audit
            }; 
        }
    },
    ClearCompletionReport: { 
        Name: "REPORT.CLEARCOMPLETIONREPORT",
        New() {
            return {
                type: reportEvents.ClearCompletionReport.Name
            }
        }
    }, 
    CompletedAuditsLoading: {
        Name: "REPORT.COMPLETEDAUDITSLOADING",
        New() {
            return {
                type: reportEvents.CompletedAuditsLoading.Name
            }; 
        }
    },
    CompletedAuditsLoaded: {
        Name: "REPORT.COMPLETEDAUDITSLOADED",
        New(data) {
            return {
                type: reportEvents.CompletedAuditsLoaded.Name,
                Data: data
            };
        }
    },
    CompletedAuditsErrored: {
        Name: "REPORT.COMPLETEDAUDITSERRORED",
        New(error) {
            return {
                type: reportEvents.CompletedAuditsErrored.Name,
                Error: error
            };
        }
    },
    GetValidAuditPeriods: { 
        Name: "REPORT.GETVALIDAUDITPERIODS", 
        New() {
            return {
                type: reportEvents.GetValidAuditPeriods.Name
            }; 
        }
    },
    GotValidAuditPeriods: {
        Name: "REPORT.GOTVALIDAUDITPERIODS", 
        New(data) { 
            return {
                type: reportEvents.GotValidAuditPeriods.Name,
                Data: data
            }; 
        } 
    }, 
    ErroredValidAuditPeriods: { 
        Name: "REPORT.ERROREDVALIDAUDITPERIODS", 
        New(error) { 
            return {
                type: reportEvents.ErroredValidAuditPeriods.Name,
                Error: error
            }; 
        }
    },
    GetCompletionReport: {
        Name: "REPORT.GETCOMPLETIONREPORT",
        New() {
            return {
                type: reportEvents.GetCompletionReport.Name
            }; 
        }
    },
    GotCompletionReport: {
        Name: "REPORT.GOTCOMPLETIONREPORT",
        New(data) {
            return {
                type: reportEvents.GotCompletionReport.Name,
                Data: data
            }; 
        }
    },
    ErroredGetCompletionReport: {
        Name: "REPORT.ERROREDGETCOMPLETIONREPORT",
        New (error) {
            return {
                type: reportEvents.ErroredGetCompletionReport.Name,
                Error: error
            }; 
        }
    },
    LoadingCompleteReport: {
        Name: "REPORT.LOADINGCOMPLETEREPORT",
        New(data) {
            return {
                type: reportEvents.LoadingCompleteReport.Name,
                Data: data
            }
        }
    },
    GetDistrictReport: {
        Name: "REPORT.GETDISTRICTREPORT",
        New() {
            return {
                type: reportEvents.GetDistrictReport.Name
            }
        }
    },
    GotDistrictReport: {
        Name: "REPORT.GOTDISTRICTREPORT",
        New(data) {
            return {
                type: reportEvents.GotDistrictReport.Name,
                Data: data
            }
        }
    },
    ErroredGetDistrictReport: {
        Name: "REPORT.ERROREDDISTRICTREPORT",
        New(error) {
            return {
                type: reportEvents.ErroredGetDistrictReport.Name,
                Error: error
            }
        }
    }
};

module.exports = reportEvents;


// WEBPACK FOOTER //
// ./src/events/reports/reportEvents.js